import * as THREE from "three";

export type CameraRig = {
  camera: THREE.PerspectiveCamera;
  target: THREE.Vector3;
};

export function createCameraRig(): CameraRig {
  const target = new THREE.Vector3(0, 0.5, 0);
  const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
  camera.position.set(2, 1.5, 3.2);
  camera.lookAt(target);
  return { camera, target };
}
